const HIDDEN_TYPES = [
  "Filter Type - Category (JDE - don't use)",
  'Filter Type - Sub Category (JDE)',
];

export default function getSpecificationRows(specs, { size, sizeLabel, order = [] } = {}) {
  const groups = new Map();

  (specs || []).forEach(spec => {
    const name = spec?.type?.name;
    const label = spec?.type?.filterType?.trim();
    const value = spec?.value?.trim();
    if (!name || !label || !value || HIDDEN_TYPES.includes(name)) return;

    if (!groups.has(name)) groups.set(name, { name, label, values: [] });
    const { values } = groups.get(name);
    if (!values.includes(value)) values.push(value);
  });

  const list = order || [];
  const rank = ({ name }) => {
    const index = list.indexOf(name);
    return index === -1 ? list.length : index;
  };

  const rows = [...groups.values()]
    .sort((a, b) => rank(a) - rank(b))
    .map(({ label, values }) => ({
      label,
      value: values.join(', '),
    }));

  if (size?.trim() && sizeLabel?.trim()) rows.push({ label: sizeLabel.trim(), value: size.trim() });

  return rows;
}
